// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"c3eae5ae","607":"c88057a4","787":"deb0e672","796":"1e7d01e5"}[chunkId] + ".chunk.js";
};